import { SeoFaq } from 'constants/dataTypes';

const FAQJson = (
  {
    faq
  }: {
    faq: SeoFaq[];
  }
) => {

  if(!faq || faq.length === 0) { 
    return null
  }

  const faqData = faq.map((faqItem:SeoFaq) => { 

    if(faqItem == null ||faqItem.error) {
      // console.log('FAQ ERROR: ');
      // console.log(faq);
      // console.log(faqItem);
      //throw new Error('faqItem error' + faqItem.error);
      return null;
    }
    return ({
      "@type": "Question",
      "name": faqItem.question || '',
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faqItem.answer
      }
    });

  }).filter(item => item !== null);;


  return (<script
    type="application/ld+json"
    dangerouslySetInnerHTML={{
        __html: JSON.stringify({
            '@context': 'https://schema.org/',
            '@type': 'FAQPage',
            mainEntity: faqData
        })
    }}
/>);
};

export default FAQJson;
